import React from 'react';
import { DocumentAutocomplete } from './DocumentAutocomplete';
import styles from '../Editor/MarkdownEditor.module.css';

interface DocumentEditorProps {
  content: string;
  uploadingImage: boolean;
  isDraggingOver: boolean;
  textareaRef: React.RefObject<HTMLTextAreaElement>;
  handleContentChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  handleDragEnter: (e: React.DragEvent<HTMLTextAreaElement>) => void;
  handleDragOver: (e: React.DragEvent<HTMLTextAreaElement>) => void;
  handleDragLeave: (e: React.DragEvent<HTMLTextAreaElement>) => void;
  handleDrop: (e: React.DragEvent<HTMLTextAreaElement>) => void;
  handlePaste: (e: React.ClipboardEvent<HTMLTextAreaElement>) => void;
  showAutocomplete: boolean;
  filteredDocuments: any[];
  autocompleteSelectedIndex: number;
  autocompletePosition: { top: number; left: number };
  handleDocumentSelect: (doc: any) => void;
}

export const DocumentEditor: React.FC<DocumentEditorProps> = ({
  content,
  uploadingImage,
  isDraggingOver,
  textareaRef,
  handleContentChange,
  handleKeyDown,
  handleDragEnter,
  handleDragOver,
  handleDragLeave,
  handleDrop,
  handlePaste,
  showAutocomplete,
  filteredDocuments,
  autocompleteSelectedIndex,
  autocompletePosition,
  handleDocumentSelect,
}) => {
  return (
    <div className={styles.editorPanel} style={{ position: 'relative' }}>
      <div className={styles.panelHeader}>
        Markdown Editor
        <span style={{ marginLeft: 'auto', fontSize: '11px', opacity: 0.7, textTransform: 'none' }}>
          {uploadingImage ? 'Uploading image...' : 'Write your content here'}
        </span>
      </div>
      <textarea
        ref={textareaRef}
        className={styles.editorTextarea}
        style={{
          borderColor: isDraggingOver ? 'var(--accent)' : undefined,
          borderWidth: isDraggingOver ? '2px' : undefined,
          borderStyle: isDraggingOver ? 'dashed' : undefined
        }}
        value={content}
        onChange={handleContentChange}
        onKeyDown={handleKeyDown}
        onDragEnter={handleDragEnter}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onPaste={handlePaste}
        disabled={uploadingImage}
        placeholder="# Start writing your markdown here...

## You can use:
- **Bold** and *italic* text
- Code blocks with syntax highlighting
- Mathematical equations
- Mermaid diagrams
- Tables, lists, and more!
- [[Wiki-style links]] - Type [[ to link to other documents
- Drag-and-drop or paste images directly!

Type away and see the live preview on the right →"
      />
      {showAutocomplete && filteredDocuments.length > 0 && (
        <DocumentAutocomplete
          documents={filteredDocuments}
          selectedIndex={autocompleteSelectedIndex}
          onSelect={handleDocumentSelect}
          onSelectedIndexChange={() => {}}
          position={autocompletePosition}
        />
      )}
    </div>
  );
};
